/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Society model module.
 * @module model/Society
 * @version v1
 */
class Society {
    /**
     * Constructs a new <code>Society</code>.
     * @alias module:model/Society
     * @param societyId {Number} 
     * @param storeId {Number} 
     * @param offerId {Number} 
     */
    constructor(societyId, storeId, offerId) { 
        
        Society.initialize(this, societyId, storeId, offerId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, societyId, storeId, offerId) { 
        obj['SocietyId'] = societyId;
        obj['StoreId'] = storeId;
        obj['OfferId'] = offerId;
    }

    /**
     * Constructs a <code>Society</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Society} obj Optional instance to populate.
     * @return {module:model/Society} The populated <code>Society</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Society();

            if (data.hasOwnProperty('SocietyId')) {
                obj['SocietyId'] = ApiClient.convertToType(data['SocietyId'], 'Number');
            }
            if (data.hasOwnProperty('StoreId')) {
                obj['StoreId'] = ApiClient.convertToType(data['StoreId'], 'Number');
            }
            if (data.hasOwnProperty('OfferId')) {
                obj['OfferId'] = ApiClient.convertToType(data['OfferId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Society</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Society</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of Society.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

Society.RequiredProperties = ["SocietyId", "StoreId", "OfferId"];

/**
 * @member {Number} SocietyId
 */
Society.prototype['SocietyId'] = undefined;

/**
 * @member {Number} StoreId
 */
Society.prototype['StoreId'] = undefined;

/**
 * @member {Number} OfferId
 */
Society.prototype['OfferId'] = undefined;






export default Society;

